import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Card, Col, Row } from "react-bootstrap";
import { Trash } from "react-bootstrap-icons";
import FormRepeater from "../../../../../../../common/FormReapeater.jsx"
import ButtonWithIcon from "../../../../../../../common/ButtonWithIcon.jsx";
import InputWiz from "../../../../../../../common/inputs/wizard/InputWiz.jsx";
import SelectWiz from "../../../../../../../common/inputs/wizard/SelectWiz.jsx";
import {usePozycjeSlownika} from "../../../../../../../../api/domain/slowniki/queries/usePozycjeSlownika.jsx";

export const RyzykaKatBRepeater = (props) => {
    const parent = props.parentListName || 'ryzyka_list'

    const raw = usePozycjeSlownika('ryzyka')
    const data = raw?.data || raw?.list || []
    const ryzyka = Array.isArray(data) ? data : (data?.list || []);

    const categoryValues = [...new Set(ryzyka.map(item => item.kategoria).filter(Boolean))];
    const categoryOptions = categoryValues.map(cat => ({ label: cat, value: cat }));

    useEffect(() => {
        const list = props.wiz?.form?.[parent] || []
        if (!Array.isArray(list)) return
        if (ryzyka.length === 0) return // Poczekaj aż słownik się załaduje

        let changed = false
        const newList = list.map((r, idx) => {
            const desiredLp = idx + 1;

            // Sprawdź czy wybrane ryzyko należy do aktualnej kategorii
            const currentKategoria = r?.kategoria || ''
            const currentRyzyko = r?.ryzyko || ''
            let shouldClearRyzyko = false
            
            if (currentRyzyko && currentKategoria) {
                const validRisksForCategory = ryzyka
                    .filter(item => item.kategoria === currentKategoria && item.opis)
                    .map(item => item.opis)
                shouldClearRyzyko = !validRisksForCategory.includes(currentRyzyko)
            }

            if (r?.lp !== desiredLp || shouldClearRyzyko) {
                changed = true
                return {
                    ...r,
                    lp: desiredLp,
                    ...(shouldClearRyzyko ? { ryzyko: '' } : {}),
                }
            }
            return r
        })

        if (changed) {
            props.wiz.setValue(parent, newList)
        }
    }, [JSON.stringify(props.wiz?.form?.[parent] || []), ryzyka])

    return (
        <FormRepeater
            value={props.wiz.form?.[parent] || []}
            onChange={(list) => props.wiz.setValue(parent, list)}
            addButtonText="Dodaj ryzyko"
            hideNativeDelete
            form={(row, setRow, idx, remove) => {
                const currentRow = {...row};
                const displayLp = currentRow.lp || (idx + 1);
                const selectCategory = currentRow.kategoria || '';
                const selectRisk = selectCategory
                    ? ryzyka
                        .filter(item => item.kategoria === selectCategory && item.opis)
                        .map(item => ({label: item.opis, value: item.opis}))
                    : [];

                return(
                    <Card className={'d-flex flex-column gap-3 mb-3 w-100'} key={idx}>
                        <Card.Header className={'d-flex justify-content-between align-items-center'}>
                            <div className={'fw-bold'}>{`Ryzyko ${displayLp}`}</div>
                            <ButtonWithIcon
                                text={`Usuń ryzyko ${displayLp}`}
                                onClick={() => remove(idx)}
                                icon={<Trash/>}
                                variant={'danger'}
                            />
                        </Card.Header>
                        <Card.Body className={''}>
                            <Row className={'mb-3 align-items-end'}>
                                <Col xs={12} md={1}>
                                    <InputWiz
                                        wiz={props.wiz}
                                        keyName={`${parent}.${idx}.lp`}
                                        row={currentRow}
                                        setRow={setRow}
                                        idx={idx}
                                        onlyNumbers
                                        readOnly={true}
                                        disabled={true}
                                        label={`Lp.`}
                                        value={displayLp}
                                    />
                                </Col>

                                <Col xs={12} md={2}>
                                    <SelectWiz
                                        wiz={props.wiz}
                                        keyName={`${parent}.${idx}.kategoria`}
                                        row={currentRow}
                                        setRow={setRow}
                                        idx={idx}
                                        options={categoryOptions}
                                        label={`Kategoria`}
                                    />
                                </Col>

                                <Col xs={12} md={9}>
                                    <SelectWiz
                                        wiz={props.wiz}
                                        keyName={`${parent}.${idx}.ryzyko`}
                                        row={currentRow}
                                        setRow={setRow}
                                        idx={idx}
                                        options={selectRisk}
                                        label={`Ryzyko`}
                                    />
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                )}}
        />
    )
}

RyzykaKatBRepeater.propTypes = {
    wiz: PropTypes.any.isRequired,
    parentListName: PropTypes.string,
}
export default RyzykaKatBRepeater